import * as React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
import styled from 'styled-components';
import { isEmpty } from 'lodash';
import type { WrappedComponentProps } from 'react-intl-next';
import { injectIntl } from 'react-intl-next';
import type { KnowledgeArticle } from 'state/ui/search';
import { SearchResultKb } from 'view/common/result-kb';
import type { WithAnalyticsEventsProps } from '@atlaskit/analytics-next';
import { withAnalyticsEvents } from '@atlaskit/analytics-next';
import FeatureGates from '@atlaskit/feature-gate-js-client';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { TRACK_EVENT_TYPE } from '@atlassian/analytics-web-react';
import { FieldBase } from '../field-base';
import messages from './messages';

interface KbSuggestionFieldProps {
    articles: KnowledgeArticle[];
    connectedToForm?: boolean;
    portalId?: number;
}

export const KbSuggestionField: React.FunctionComponent<
    KbSuggestionFieldProps & WrappedComponentProps & WithAnalyticsEventsProps
> = ({ createAnalyticsEvent, articles, intl, connectedToForm, portalId }) => {
    React.useEffect(() => {
        createAnalyticsEvent &&
            createAnalyticsEvent({
                action: 'viewed',
                analyticsType: TRACK_EVENT_TYPE,
                actionSubjectId: `kbSuggestion${connectedToForm ? '-proforma' : ''}`,
                actionSubject: `kbSuggestionField${connectedToForm ? '-proforma' : ''}`,
                totalArticles: articles.length,
            }).fire();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [createAnalyticsEvent, articles.length]);
    return (
        <Root>
            <FieldBase htmlFor="kb-suggest-article" label={intl.formatMessage(messages.label)}>
                {!isEmpty(articles) && (
                    <Container>
                        {articles.map((article) => (
                            <KbArticle
                                articleUrl={
                                    FeatureGates.checkGate('3p-integration-enabled_t5ysh')
                                        ? article.articleUrl
                                        : undefined
                                }
                                sourceType={
                                    FeatureGates.checkGate('3p-integration-enabled_t5ysh')
                                        ? article.sourceType
                                        : undefined
                                }
                                key={article.id}
                                elevated={false}
                                title={article.name}
                                openNewTab
                                focusable
                                isSuggestion
                                portalId={typeof portalId === 'number' ? portalId.toString() : portalId}
                                {...article}
                            />
                        ))}
                    </Container>
                )}
            </FieldBase>
        </Root>
    );
};

export default withAnalyticsEvents()(injectIntl(KbSuggestionField));

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const Root = styled.div`
    width: 100%;
`;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const Container = styled.div<{ isSmartSnippetsEnabled?: boolean }>`
    padding: ${token('space.200', '16px')};
    background-color: ${token('color.background.neutral', colors.N10)};
`;

// eslint-disable-next-line rulesdir/no-styled-export, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const KbArticle = styled(SearchResultKb)`
    transition: box-shadow 0.2s ease-in-out;
`;
